import { useMemo } from 'react';

const ROUTES_REGEX = /^\/(article|case)\//;

export const useAbsolutePosition = pathname =>
  useMemo(() => ROUTES_REGEX.test(pathname), [pathname]);
